import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, type PointerEvent as ReactPointerEvent, useEffect, useRef, useState } from 'react';
type Options = {
  disabled?: boolean;
  itemIds: readonly string[];
  onReorder: (from: number, to: number) => void;
};
const useNavReorder = t0 => {
  const $ = _c(21);
  const {
    disabled: t1,
    itemIds,
    onReorder
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const listRef = useRef(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);
  const suppressClick = useRef(false);
  const cleanupRef = useRef(_temp);
  const cancelRef = useRef(_temp2);
  let t2;
  if ($[0] !== disabled || $[1] !== onReorder) {
    t2 = {
      disabled,
      onReorder
    };
    $[0] = disabled;
    $[1] = onReorder;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const optionsRef = useRef(t2);
  let t3;
  let t4;
  if ($[3] !== disabled || $[4] !== onReorder) {
    t3 = () => {
      optionsRef.current = {
        disabled,
        onReorder
      };
      if (disabled) {
        cancelRef.current();
      }
    };
    t4 = [disabled, onReorder];
    $[3] = disabled;
    $[4] = onReorder;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => () => cleanupRef.current();
    t6 = [];
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== itemIds) {
    t7 = itemIds.join("|");
    $[9] = itemIds;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const orderKey = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      cancelRef.current();
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== orderKey) {
    t9 = [orderKey];
    $[12] = orderKey;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  useEffect(t8, t9);
  let t10;
  if ($[14] !== disabled) {
    t10 = (event, index) => {
      if (disabled || event.button !== 0 || event.isPrimary === false) {
        return;
      }
      cancelRef.current();
      suppressClick.current = false;
      const startY = event.clientY;
      const pointerId = event.pointerId;
      let active = false;
      let target = null;
      const finish = commit => {
        cleanupRef.current();
        setDragIndex(null);
        setDropIndex(null);
        if (!commit || !active || target === null || optionsRef.current.disabled) {
          return;
        }
        const to = target > index ? target - 1 : target;
        if (to !== index) {
          optionsRef.current.onReorder(index, to);
        }
      };
      const onMove = moveEvent => {
        if (moveEvent.pointerId !== pointerId) {
          return;
        }
        if (!active && Math.abs(moveEvent.clientY - startY) < 4) {
          return;
        }
        active = true;
        suppressClick.current = true;
        setDragIndex(index);
        const rows = Array.from(listRef.current?.children ?? []);
        const next = rows.findIndex(row => {
          const rect = row.getBoundingClientRect();
          return moveEvent.clientY < rect.top + rect.height / 2;
        });
        target = next === -1 ? rows.length : next;
        setDropIndex(target);
        moveEvent.preventDefault();
      };
      const onUp = upEvent => {
        if (upEvent.pointerId === pointerId) {
          finish(true);
        }
      };
      const onCancel = cancelEvent => {
        if (cancelEvent.pointerId === pointerId) {
          finish(false);
        }
      };
      const onBlur = () => finish(false);
      const onKeyDown = keyEvent => {
        if (keyEvent.key === "Escape") {
          finish(false);
        }
      };
      cleanupRef.current = () => {
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onCancel);
        window.removeEventListener("blur", onBlur);
        window.removeEventListener("keydown", onKeyDown);
        cleanupRef.current = _temp3;
        cancelRef.current = _temp4;
      };
      cancelRef.current = () => finish(false);
      window.addEventListener("pointermove", onMove, {
        passive: false
      });
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onCancel);
      window.addEventListener("blur", onBlur);
      window.addEventListener("keydown", onKeyDown);
    };
    $[14] = disabled;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const startDrag = t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event_0 => {
      if (!suppressClick.current || event_0.detail === 0) {
        return;
      }
      suppressClick.current = false;
      event_0.preventDefault();
      event_0.stopPropagation();
    };
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const onClickCapture = t11;
  let t12;
  if ($[17] !== dragIndex || $[18] !== dropIndex || $[19] !== startDrag) {
    t12 = {
      listRef,
      dragIndex,
      dropIndex,
      startDrag,
      onClickCapture
    };
    $[17] = dragIndex;
    $[18] = dropIndex;
    $[19] = startDrag;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
export default useNavReorder;
function _temp() {}
function _temp2() {}
function _temp3() {}
function _temp4() {}